module.exports = __webpack_public_path__ + "media/flags/na-a6489bdf.svg";